import type {
  SingleDataPoint,
  TransitionBreakdownData,
} from '../../../../DataProvider/types';
import type { SheetData } from '../types';

type TransitionFlowDataSet = {
  data: TransitionBreakdownData[];
};

export const isTransitionFlowDataSet = (
  data: unknown
): data is TransitionFlowDataSet => {
  const entries = (data as { data?: unknown })?.data;
  return (
    Array.isArray(entries) &&
    entries.some((entry) => {
      const flowEntry = entry as TransitionBreakdownData | undefined;
      return (
        Array.isArray(flowEntry?.inflowBreakdown) ||
        Array.isArray(flowEntry?.outflowBreakdown)
      );
    })
  );
};

export const convertTransitionFlowDataToSheet = ({
  data,
}: {
  data: TransitionFlowDataSet;
}): SheetData[] => {
  const rows: SheetData[] = [];

  const pushRows = (
    primary: string,
    points: SingleDataPoint[] | undefined,
    direction: 'Inflow' | 'Outflow'
  ) => {
    points?.forEach((point) => {
      if (!point.dim) return;
      rows.push({
        Direction: direction,
        From: direction === 'Inflow' ? point.dim : primary,
        To: direction === 'Inflow' ? primary : point.dim,
        Count: point.value ?? 0,
        Share: point.share ?? 0,
      });
    });
  };

  data.data.forEach((entry) => {
    if (!entry.dim) return;
    pushRows(entry.dim, entry.inflowBreakdown, 'Inflow');
    pushRows(entry.dim, entry.outflowBreakdown, 'Outflow');
  });

  return rows;
};
